import React from 'react'

import { Formik } from 'formik'

import { Form, Modal, Button, Row, Col } from '_zari/core'

import { ZariContext } from '_zari/context'

import * as FormGroups from './formGroups'

import * as ActivoFijoService from 'services/activosFijos.service'

const ActivoFijoModal = ({ show, handleClose, modalData, refreshActivosFijos, setActivoFijoAnteriorData }) => {
  const __zariContext = React.useContext(ZariContext)
  const [nuevoCodigo, setNuevoCodigo] = React.useState('')

  React.useEffect(() => {
    ActivoFijoService.nuevoCodigo().then(({ data }) => {
      setNuevoCodigo(data.nuevoCodigo)
    })
  }, [])

  const formInitialValues = React.useMemo(() => {
    return {
      codigo: '',
      codigoGeneradoFlag: true,
      cuentaContable: modalData.cuentaContable || '',
      depreciacionAnual: modalData.depreciacionAnual || '',
      descripcion: '',
      fechaAdquisicion: modalData.fecha || '',
      fechaUso: modalData.fecha || '',
      marca: '',
      metodoDepreciacion: '',
      modelo: '',
      numeroAutorizacion: '',
      serie: '',
      _idCentroCostoNivel1: modalData._idCentroCostoNivel1 || '',
      _idCentroCostoNivel2: modalData._idCentroCostoNivel2 || '',
      centroCostoNivel1Info: modalData.centroCostoNivel1Info || '',
      centroCostoNivel2Info: modalData.centroCostoNivel2Info || '',
      cuentaContableDebe: modalData.cuentaContableDebe || '',
      cuentaContableDebeInfo: modalData.cuentaContableDebeInfo || '',
      cuentaContableHaber: modalData.cuentaContableHaber || '',
      cuentaContableHaberInfo: modalData.cuentaContableHaberInfo || ''
    }
  }, [modalData])

  const onSubmit = React.useCallback(
    (data, { setSubmitting }) => {
      if (data.codigo === '') {
        data.codigo = nuevoCodigo
      }
      ActivoFijoService.nuevoActivoModal(data)
        .then(() => {
          __zariContext.snack('success', 'Activo Fijo Creado')
          setActivoFijoAnteriorData({
            depreciacionAnual: data.depreciacionAnual || '',
            _idCentroCostoNivel1: data._idCentroCostoNivel1 || '',
            _idCentroCostoNivel2: data._idCentroCostoNivel2 || '',
            centroCostoNivel1Info: data.centroCostoNivel1Info || '',
            centroCostoNivel2Info: data.centroCostoNivel2Info || '',
            cuentaContableDebe: data.cuentaContableDebe || '',
            cuentaContableDebeInfo: data.cuentaContableDebeInfo || '',
            cuentaContableHaber: data.cuentaContableHaber || '',
            cuentaContableHaberInfo: data.cuentaContableHaberInfo || ''
          })
          refreshActivosFijos()
          handleClose()
        })
        .catch(({ data: { error } }) => {
          __zariContext.snack('error', error)
          setSubmitting(false)
        })
    },
    [__zariContext, handleClose, nuevoCodigo, refreshActivosFijos, setActivoFijoAnteriorData]
  )

  return (
    <Modal show={show} centered size='md'>
      <Modal.Header>
        <Modal.Title>ACTIVO FIJO MODAL</Modal.Title>
      </Modal.Header>
      <Formik initialValues={formInitialValues} onSubmit={onSubmit}>
        {({ errors, touched, isSubmitting, values, handleSubmit, handleChange, setFieldValue, setValues }) => (
          <>
            <Modal.Body>
              <Form>
                <Row>
                  <Col md={12}>
                    <FormGroups.DescripcionFormGroup
                      iError={errors.descripcion}
                      iTouched={touched.descripcion}
                      fIsSubmitting={isSubmitting}
                      handleChange={handleChange}
                      setFieldValue={setFieldValue}
                    />
                  </Col>
                  <Col md={12}>
                    <FormGroups.DepreciacionAnualFormGroup
                      iError={errors.depreciacionAnual}
                      iTouched={touched.depreciacionAnual}
                      fIsSubmitting={isSubmitting}
                      handleChange={handleChange}
                      setFieldValue={setFieldValue}
                    />
                  </Col>
                  <Col md={12}>
                    <FormGroups.CentroCostoNivel1FormGroup
                      iError={errors._idCentroCostoNivel1}
                      iTouched={touched._idCentroCostoNivel1}
                      fIsSubmitting={isSubmitting}
                      handleChange={handleChange}
                      setFieldValue={setFieldValue}
                    />
                  </Col>
                  {values._idCentroCostoNivel1 && (
                    <Col md={12}>
                      <FormGroups.CentroCostoNivel2FormGroup
                        iError={errors._idCentroCostoNivel2}
                        iTouched={touched._idCentroCostoNivel2}
                        setFieldValue={setFieldValue}
                        iValue={values.centroCostoNivel2Info}
                        idNodoPadre={values._idCentroCostoNivel1}
                      />
                    </Col>
                  )}
                  <Col md={12}>
                    <FormGroups.CuentaContableDebeFormGroup
                      iError={errors.cuentaContableDebe}
                      iTouched={touched.cuentaContableDebe}
                      iValue={values.cuentaContableDebeInfo}
                      setFieldValue={setFieldValue}
                    />
                  </Col>
                  <Col md={12}>
                    <FormGroups.CuentaContableHaberFormGroup
                      iError={errors.cuentaContableHaber}
                      iTouched={touched.cuentaContableHaber}
                      iValue={values.cuentaContableHaberInfo}
                      setFieldValue={setFieldValue}
                    />
                  </Col>
                </Row>
              </Form>
            </Modal.Body>
            <Modal.Footer>
              <Button color='secondary' onClick={handleClose} disabled={isSubmitting}>
                Cancelar
              </Button>
              <Button id='button-ActivoFijoModal-procesar' onClick={handleSubmit} disabled={isSubmitting}>
                Guardar
              </Button>
            </Modal.Footer>
          </>
        )}
      </Formik>
    </Modal>
  )
}

export default React.memo(ActivoFijoModal)
